// const RosterTypes = {
//   ROSTER: 'roster',
// }

// const SubTypes = {
//   SUB: 'sub',
// }
  
// const allTypes = [
//   RosterTypes,
//   SubTypes
// ]

const ItemTypes = {
  LINEUP: 'lineup',
  ROSTER: 'roster',
  SUB: 'sub'
}

export default ItemTypes 
